import React from 'react';
import CheckActive from '@/assets/icons/simpleTextAdvices/check_icon.svg';
import { useSelector } from 'react-redux';
import { removeHoursFromDate } from '@/utils/functions/formatTimeDate';
import { Link } from 'react-router-dom';
import styles from '@/views/components/SimpleTextAdivse/QuestionShort/QuestionShort.module.scss';

const QuestionShort = ({question, showPublished = false, isPublic, myAdvices}) => {
	const dict = useSelector(state => state.app.dict);

	const {content, createdOn, category, id, published, answer} = question;

	return (
		<div className={ styles['question'] }>
			<div className={ `${styles['question__inner']} ${answer && !isPublic && !answer.read && styles['question__inner--unread']}` }>
				<div className={ styles['question__header'] }>
					<p className={ styles['question__header__text'] }>{dict.simpleTextAdvices.question.title} {id}</p>
					{category?.name && <div className={ styles['question__categoryBox'] }>
						<p className={ styles['question__category'] }>{category.name}</p>
					</div>}
				</div>
				<p className={ styles['question__description'] }> 
					{content}
				</p>
				<div className={ styles['question__footer'] }>
					<div className={ styles['question__footer__left'] }>
						<p className={ styles['question__date'] }>
							{!answer ? dict.simpleTextAdvices.question.date : dict.simpleTextAdvices.question.adviceDate} {removeHoursFromDate(createdOn).replaceAll('-', '.')}  
						</p>
						{showPublished && <>						
							<div className={ styles['question__divider'] } /> 
							<p className={ styles['question__date'] }>{answer ? (published ? dict.simpleTextAdvices.question.published : dict.simpleTextAdvices.question.unpublished) : 'Oczekiwanie na odpowiedź'}</p>
						</>}
					</div>
					<div className={ styles['question__footer__right'] }>
						{answer && !isPublic && (answer.read ? 
							<div className={ styles['question__readed-container'] }> 
								<img 
									src={ CheckActive }
									alt={ dict.simpleTextAdvices.question.alt.confirm }
								/>
								<p className={ styles['question__readed'] }>{dict.simpleTextAdvices.question.read}</p>
							</div> : 
							<div className={ styles['question__readed-container'] }>
								<div className={ styles['question__dot'] }/>
								<p className={ styles['question__readed'] }>{dict.simpleTextAdvices.question.unread}</p>
							</div>
						)
						}
						<Link
							className={ `button__white` } 
							to={ `/simple-text-advice/${id}${myAdvices ? '?my-advices' : ''}` }
						>
							{answer ? dict.simpleTextAdvices.question.viewAdviceDetails : dict.simpleTextAdvices.question.viewQuestionDetails} <div className={ `icon-arrow-right-full` } />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QuestionShort;